module.exports = __webpack_public_path__ + "img/receta-icon.aec431b1.png";